import { render, staticRenderFns } from "./TableHeaderCell.vue?vue&type=template&id=a887b544&scoped=true"
import script from "./TableHeaderCell.vue?vue&type=script&lang=js"
export * from "./TableHeaderCell.vue?vue&type=script&lang=js"
import style0 from "./TableHeaderCell.vue?vue&type=style&index=0&id=a887b544&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a887b544",
  null
  
)

export default component.exports